import { chosenSites } from "app/common/services/chosenSites";
import type { CompetitiveSiteFilter } from "../types/common";

const getChosenSitesFilters = (): CompetitiveSiteFilter[] =>
    chosenSites.map((item: string, infoItem: { icon: string; displayName: string }) => {
        return { value: item, label: infoItem.displayName, icon: infoItem.icon };
    });

export default getChosenSitesFilters;
